import { render, staticRenderFns } from "./RoiHistoryModal.vue?vue&type=template&id=9286f4ca&"
import script from "./RoiHistoryModal.vue?vue&type=script&lang=js&"
export * from "./RoiHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports